/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClearCompanyLogoUrlsRequest
 */
export interface ClearCompanyLogoUrlsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClearCompanyLogoUrlsRequest
     */
    normalizedCompanyNames: Array<string>;
}

/**
 * Check if a given object implements the ClearCompanyLogoUrlsRequest interface.
 */
export function instanceOfClearCompanyLogoUrlsRequest(value: object): value is ClearCompanyLogoUrlsRequest {
    if (!('normalizedCompanyNames' in value) || value['normalizedCompanyNames'] === undefined) return false;
    return true;
}

export function ClearCompanyLogoUrlsRequestFromJSON(json: any): ClearCompanyLogoUrlsRequest {
    return ClearCompanyLogoUrlsRequestFromJSONTyped(json, false);
}

export function ClearCompanyLogoUrlsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClearCompanyLogoUrlsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'normalizedCompanyNames': json['normalizedCompanyNames'],
    };
}

export function ClearCompanyLogoUrlsRequestToJSON(value?: ClearCompanyLogoUrlsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'normalizedCompanyNames': value['normalizedCompanyNames'],
    };
}

